import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { myBookFollow, getSandbox } from "../lib/api";

// "Follow me": while a teacher of one of the kid's groups leads a book, the kid's tablet stays in that book. It is opened
// from any page of the app (checked every 4 s while the app is visible), and any other BUMA page the kid opens sends them
// straight back to the book. The book page itself then fills the screen (BookLock) and follows the teacher's page turns.
// It ends when the teacher turns "Follow me" off (or it times out on the server).
export function useFollowPull(on, lang = "en") {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const lead = useRef(null);  // { cid, fid, class_id, page } while a teacher leads
  const told = useRef("");
  const bring = (f, first) => {
    const target = `/book/${f.cid}/${f.fid}`;
    if (window.location.pathname === target) return;
    window.dispatchEvent(new Event("kid:leave"));  // unsaved work on the current page is saved first
    navigate(`${target}?class_id=${f.class_id}&page=${f.page}`, { replace: !first });
    const key = `${f.class_id}:${f.fid}`;
    if (told.current !== key || !first) toast.info(lang === "ar" ? "معلّمك يقرأ مع الصف — تابع في الكتاب!" : "Your teacher is reading with the class — stay in the book!");
    told.current = key;
  };
  useEffect(() => {
    if (!on || getSandbox()) { lead.current = null; return undefined; }
    let dead = false;
    const tick = async () => {
      if (document.hidden) return;
      try {
        const { follow: f } = await myBookFollow();
        if (dead) return;
        const was = lead.current; lead.current = f || null;
        if (f) bring(f, !was || was.fid !== f.fid);
      } catch (e) { /* offline / logged out: try again next time */ }
    };
    tick(); const iv = setInterval(tick, 4000);
    return () => { dead = true; clearInterval(iv); };
  }, [on, navigate, lang]);  // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {  // the kid opened another page while the teacher leads → straight back to the book
    if (on && lead.current) bring(lead.current, false);
  }, [pathname, on]);  // eslint-disable-line react-hooks/exhaustive-deps
}
